<template>
		<div>
			<div class="d-flex align-items-center mb-3">
				<div>
					<h1 class="page-header mb-0"><i class="fas fa-hard-hat"></i> Munkaterületek</h1>
				</div>
				<div class="ms-auto" v-if="user && user.role_id == 1">
					<button class="btn btn-success btn-rounded px-4 rounded-pill" @click="addMain()"><i class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új munkaterület</button>
				</div>
			</div>
			<b-modal id="addLocationModal" cancel-variant="default" @cancel="closeAddModal()" @ok="addLocation" ok-title="Létrehozás" cancel-title="Mégse" :ok-disabled="loading">
				<template slot="modal-header">
					<h4 class="modal-title">Új munkaterület</h4>
					<a class="btn-close" @click="closeAddModal()"></a>
				</template>
				<form @submit.prevent="addLocation()" ref="location_modal_form" v-if="loading == false">
					<div class="form-group">
						<label class="form-label">Megnevezés:</label>
						<input class="form-control text-center" :class="{'is-invalid' : errors.name}" type="text" v-model="location.name" required>
						<div v-if="errors.name" class="invalid-feedback d-block">{{errors.name[0]}}</div>
					</div>
				</form>
				<Loading v-else title="Létrehozás"></Loading>
			</b-modal>
			<panel title="Munkaterületek">
				<Loading v-if="locations === false" title="Munkaterületek betöltése"></Loading>
				<NoRecords v-if="locations.length == 0" main_icon="fas fa-user-lock" value="false" title="Nincsenek munkaterületek" subtitle="hozzon létre újat"></NoRecords>
				<LocationRow :location_leads="location_leads" @child-deleted="refreshLocations()" @child-added="addChild" v-for="location in locations" :key="location.id" :location="location" depth="0"></LocationRow>
			</panel>
	</div> 
</template>

<script>
	import Loading from '../../components/Loading';
	import NoRecords from '../../components/NoRecords';
	import LocationRow from "../../components/LocationRow"; 
	import Location from "../../apis/Location"; 
	import User from "../../apis/User"; User

	export default {
		components: {
			Loading, NoRecords, LocationRow
		},
		data() {
			return {
				locations: false,
				location:{},
				errors: [],
				loading: false,
				location_leads: false,
			}
		},
		computed:{
			user(){
					return this.$store.state.user;
				},
		},
		created() {
			this.refreshLocations();
			
			User.getRole(3)
			.then(response => {
				this.location_leads = response.data;
			})
		},
		methods: {
			refreshLocations(){
				//console.log('location index');
				Location.index()
				.then(response => {
					this.locations = response.data;
				});
			},
			addChild(id){
				this.location.parent_id = id;
				this.$bvModal.show('addLocationModal');
			},
			addMain(){
				this.location = {};
				this.$bvModal.show('addLocationModal');
			},
			closeAddModal(){
				this.location = {};
				this.errors = [];
				this.$bvModal.hide('addLocationModal')
			},
			addLocation(bvModalEvt){
				this.loading = true;
				if(bvModalEvt){ //ok gombra van csak event
					bvModalEvt.preventDefault();
				}
				Location.add(this.location)
				.then(() => {
					Location.index()
					.then(response => {
						this.$set(this,'locations',response.data);
						this.closeAddModal();
						this.errors = [];
					}).finally(() => {
						this.loading = false;
					});
				});
				
					
				/*Location.add(this.location)
				.then(response => {
					this.locations.push(response.data);
					this.errors = [];
					this.closeAddModal();
				}).catch(error => {
					if(error.response.data.errors){
						this.errors = error.response.data.errors;
					}
				}).finally(() => {
					this.loading = false;
				})*/
			},
		},
	}
</script>

<style>
	
</style>